export default __webpack_public_path__ + "static/Panacea_Brochure-da88eb7734e478fe61cff0823e5ce42c.pdf";